import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Bazel = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      clipRule="evenodd"
      d="m4.96003 2 2.87688 2.87688-2.87688 2.87688-2.87688-2.87688z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m8.11975 5.15972-2.87688 2.87688 2.87688 2.8769 2.87685-2.8769z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m4.76003 10.7135v-2.59406l-2.75972-2.75972v2.59404z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m5.16003 8.51944v2.59406l2.75972 2.7597v-2.594z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m8.31975 11.2792v2.594l2.75975-2.7597v-2.59406z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m14.2392 7.95376-2.7597 2.75974v-2.59406l2.7597-2.75972z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m11.2795 7.75376 2.8769-2.87688-2.8769-2.87688-2.87691 2.87688z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Bazel;
